import { render, staticRenderFns } from "./TripPlace.vue?vue&type=template&id=f944f86c&"
import script from "./TripPlace.vue?vue&type=script&lang=js&"
export * from "./TripPlace.vue?vue&type=script&lang=js&"
import style0 from "./TripPlace.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports